import {NavLink} from 'react-router-dom';
import './header.css';

export const Header = (props: { countFavorite: number }) => {
  const countFavorite = props.countFavorite;

  return (
    <header className="header">
      <div className="wrapper header__wrapper">
        <NavLink
          to='/'
          className='header-link'>
          <p className='link-content'>Главная</p>
        </NavLink>
        <NavLink
          to='/shop-toys'
          className='header-link'>
          <p className='link-content'>Игрушки</p>
        </NavLink>
        <NavLink
          to='/tree'
          className='header-link'>
          <p className='link-content'>Ёлка</p>
        </NavLink>

        {/*<input className="header__search"*/}
        {/*       onChange={(event) => {*/}
        {/*         setInputText(event.target.value);*/}
        {/*         searchToy(event.target.value);*/}
        {/*       }} autoFocus={true}*/}
        {/*       value={inputText}*/}
        {/*       placeholder="Поиск" type="text"/>*/}
        <div className="header__count-toys"><span>{countFavorite}</span></div>
      </div>
    </header>
  )
};